var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeOpened(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.894 8.947c1.632-3.263 6.58-3.263 8.211 0a1 1 0 001.79-.894c-2.37-4.737-9.42-4.737-11.79 0a1 1 0 101.79.894zM9 8a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpened);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ljg5NDQxIDguOTQ3MjVDNi41MjU4NyA1LjY4NDIyIDExLjQ3NDEgNS42ODQyOCAxMy4xMDU1IDguOTQ3MjZDMTMuMzUyNSA5LjQ0MTI0IDEzLjk1MzIgOS42NDE0NyAxNC40NDcyIDkuMzk0NDhDMTQuOTQxMiA5LjE0NzQ5IDE1LjE0MTQgOC41NDY4MSAxNC44OTQ0IDguMDUyODRDMTIuNTI1OSAzLjMxNTgyIDUuNDc0MDggMy4zMTU2MiAzLjEwNTU0IDguMDUyODVDMi44NTg1NiA4LjU0NjgzIDMuMDU4NzkgOS4xNDc1IDMuNTUyNzcgOS4zOTQ0OEM0LjA0Njc1IDkuNjQxNDcgNC42NDc0MyA5LjQ0MTIzIDQuODk0NDEgOC45NDcyNVpNOC45OTk5OCA4QzcuNjE5MjYgOCA2LjQ5OTk3IDkuMTE5MjkgNi40OTk5NyAxMC41QzYuNDk5OTcgMTEuODgwNyA3LjYxOTI2IDEzIDguOTk5OTggMTNDMTAuMzgwNyAxMyAxMS41IDExLjg4MDcgMTEuNSAxMC41QzExLjUgOS4xMTkyOSAxMC4zODA3IDggOC45OTk5OCA4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };